import { useContext, useEffect, useState } from "react";
import Layout from "../layouts/Layout";
import { Helmet, HelmetProvider } from "react-helmet-async";
import "./SettingsPage.css";
import "simplebar-react/dist/simplebar.min.css";
import { Context } from "../context/Context";
import "./HelpPage.css";
import { AllHelp, BackupList } from "../api/api";
import Help from "../components/Help";
import BackButton from "../components/BackButton";
import { useParams, useNavigate, useLocation } from "react-router-dom";

const HelpPage = () => {
  const { setPage, setHelpContent } = useContext(Context);

  const { "*": dynamicPath } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [backUrl, setBackUrl] = useState([]);

  useEffect(() => {
    setPage({
      name: "راهنما",
      slug: "help",
    });
    AllHelp()
      .then(({ data }) => {
        setHelpContent(data);
      })
      .catch((error) => {
        console.error("Error fetching help data:", error);
      });
  }, [setPage, setHelpContent]);

  const processedSubpath = dynamicPath
    ? decodeURIComponent(dynamicPath.replace(/_/g, " "))
    : null;

  const handleBackUrlUpdate = (newUrl) => {
    setBackUrl((prev) => [...prev, newUrl]);
  };

  return (
    <HelmetProvider>
      <Helmet>
        <title>راهنما</title>
      </Helmet>
        <div className="container-xxl flex-grow-1 container-p-y">
          <div className="col-12 col-md-10 col-lg-8 w-100 h-100 mx-auto">
            <div
              className="card h-100 shadow-none"
              style={{ backgroundColor: "transparent" }}
            >
              <div className="card-header d-flex align-items-center justify-content-between border-bottom p-0 px-1">
                <h5>راهنما</h5>
                <BackButton />
              </div>
              <div className="card-body scrollbar mt-4">
                <Help
                  backUrl={backUrl}
                  setBackUrl={handleBackUrlUpdate}
                  subpath={processedSubpath}
                  navigate={navigate}
                  currentPathname={location.pathname}
                />
              </div>
            </div>
          </div>
        </div>
    </HelmetProvider>
  );
};

export default HelpPage;
